import React from 'react';
import { AdministradoraContent } from './cadastroDeAdministradoraContent';
import { AdministradoraProvider } from './context/cadastroDeAdministradoraContext';

export const CadastroAdministradora: React.FC = () => {
  return (
    <AdministradoraProvider>
      <AdministradoraContent />
    </AdministradoraProvider>
  );
};
